import { Recipient } from '../../../../common/types/form'
import { splitEmail } from '../../../../common/components/EmailInputRecipient/helper'
import {
    CsvToRecipientData,
    COLUMN_SEPARATOR,
    GROUP_NAME_FIELD,
    LINE_SEPARATOR,
    LOOKUP_KEY_FIELD,
    LOOKUP_MACRO_FIELD,
    RECIPIENTS_EMAIL_FIELD,
    VALUES_SEPARATOR
} from './types'

export const cleanWindowsCharacters = (text: string): string => {
    if (!text || typeof text !== 'string' || text == null || text === '')
        return ''

    let clearText = text.replace(/[\r\n]+/g, LINE_SEPARATOR)
    
    return clearText
}

export const slplitClear = (text: string): string[] => {
    if (!text || typeof text !== 'string' || text == null || text === '') {
        return []
    }

    return text
        ?.split(VALUES_SEPARATOR)
        .filter(value => !!value)
        .map(value => value.replaceAll(/['"]+/g, ''))
        .map(value => value.trim())
        .filter(value => value !== '')
}

const formatStringCsvToRecipient = (text: string): CsvToRecipientData[] => {
    if (!text || typeof text !== 'string' || text == null) {
        return []
    }

    text = cleanWindowsCharacters(text)
    const fields = text?.slice(0, text?.indexOf('\n')).split(',')
    if (fields.length < 4) {
        return []
    }

    const replacedCommas = {}
    const searchRegExp = /"(.*?)"/gm
    if (searchRegExp.test(text)) {
        const texts = [...text.match(searchRegExp)]
        texts.forEach(cellInfo => {
            const replacement = cellInfo.replaceAll(',', ';')
            replacedCommas[replacement] = cellInfo 
            text = text.replace(cellInfo, replacement)
        })
    }

    const lines = text.slice(text.indexOf('\n') + 1).split('\n')

    if (!lines || lines?.length == 0) return []

    return Object.values(
        lines.reduce((state, line, lineidx) => {
            if (!!line) {
                const lineData = line.split(COLUMN_SEPARATOR).reduce((acc, cur, columnidx) => {
                    return {
                        ...acc,
                        [fields[columnidx]?.toUpperCase().trim().replaceAll('_', ' ')]: cur
                    }
                }, {})

                let groupName = lineData[GROUP_NAME_FIELD]?.trim() ?? ''
                const emails = lineData[RECIPIENTS_EMAIL_FIELD] ?? ''
                const lookupMacro = lineData[LOOKUP_MACRO_FIELD] ?? ''
                const lookupKeys = lineData[LOOKUP_KEY_FIELD] ?? ''

                if (groupName == '')
                    //maybe not to launch errors? just skip line?
                    return state //throw new Error(`Invalid group name at line ${lineidx + 1}`)
                
                if(replacedCommas[groupName] !== undefined){
                    groupName = replacedCommas[groupName].slice(1)
                    groupName = groupName.slice(0, groupName.length - 1)
                }
                
                const errors = []
                const emailFieldValues = slplitClear(emails)
                const emailsArray = emailFieldValues
                    .map(email => splitEmail(email))
                    .reduce((acc, cur) => {
                        return [...acc, ...cur]
                    }, [])

                if (emailsArray.length < emailFieldValues.length && emails.trim() != '')
                    errors.push(`Invalid recipient emails at line ${lineidx + 1}: ${emails}`)

                const lookupKeysArray = slplitClear(lookupKeys)
                //TODO MAYBE VALIDATE LOOKUPS??

                if (!state[groupName]) {
                    state[groupName] = {
                        errors: [],
                        recipient: {
                            enabled: true,
                            name: groupName,
                            recipients: [],
                            lookups: {}
                        } as Recipient
                    }
                }
                const currentRecipient = state[groupName].recipient

                const mergedEmailsArray = [...currentRecipient.recipients, ...emailsArray]

                let lookups = currentRecipient.lookups
                if (lookupMacro !== '') {
                    let mergedLookupKeys = lookups[lookupMacro] ?? []
                    mergedLookupKeys = [...mergedLookupKeys, ...lookupKeysArray]
                    lookups = {
                        ...lookups,
                        [lookupMacro]: [...new Set(mergedLookupKeys)]
                    }
                }
                state[groupName] = {
                    errors: [...state[groupName].errors, ...errors],
                    recipient: {
                        ...currentRecipient,
                        recipients: [...new Set(mergedEmailsArray)],
                        lookups: lookups
                    } as Recipient
                }
            }
            return state
        }, {} as CsvToRecipientData)
    )
}

export default formatStringCsvToRecipient
